export default __webpack_public_path__ + "static/media/Alien_Invasion.f0caf9a1.png";